<template>
<div>
    <div class="container">
        <div class="d-flex justify-content-between">
            <div class="mt-3 mb-4">
                <button type="button" class="btn btn-secondary" @click="mtdChangeView('box')">
                    <i class="fas fa-arrow-left"></i> Volver
                </button>
            </div>
            <div class=" btn-home mt-3 mb-4">
                <button type="button" class="btn btn-outline-main" @click="mtdChangeView('home')">
                    <i class="fas fa-home-lg-alt"></i> Inicio
                </button>
            </div>
        </div>
        <div id="div-modal-cxc" class="d-flex justify-content-center">
            <div id="div-cxc" class="card w-100 mb-lg-5">
                <div class="text-center card-header text-white h4 bg-main">
                    <strong>ORDEN DE TRABAJO</strong>
                </div>
                <div class="card-body w-100">
                    <div class="row">
                        <div class="col-md-12 py-1 px-3">
                            <div class="row d-flex">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-2">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text col-md-4">Desde</span>
                                        <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="begindate" v-model="filter.init" @change="mtdGetData" />
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-2">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text col-md-4">Hasta</span>
                                        <input type="date" aria-label="shift_date" class="form-control form-control-sm" id="end" v-model="filter.end" @change="mtdGetData" />
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex">
                                <div class="col-md-12 mb-2">
                                    <div class="input-group input-group">
                                        <span class="input-group-text text-white bg-main">
                                            <i class="fas fa-search"></i>
                                        </span>
                                        <input
                                            @keyup="calculateData(10)"
                                            v-model="search"
                                            type="text"
                                            class="form-control form-control-sm"
                                            placeholder="Buscar Dni o Nombre"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-2">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text text-white bg-main">
                                            <i class="fas fa-search"></i>
                                        </span>
                                        <select id="estadoPago" class="form-control form-control-sm" style="cursor: pointer;" v-model="searchPa" @change="calculateData(10)">
                                            <option value="" disabled selected>Seleccione Estado Pago</option>
                                            <option value="0" class="bg-info text-white">Todos</option>
                                            <option value="1" class="bg-danger text-white">Sin Pago</option>
                                            <option value="2" class="bg-warning">Pago Parcial</option>
                                            <option value="3" class="bg-success text-white">Pagado</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                    <div class="input-group input-group-sm">
                                        <span class="input-group-text text-white bg-main">
                                            <i class="fas fa-search"></i>
                                        </span>
                                        <select id="estadoPago" class="form-control form-control-sm" style="cursor: pointer;" v-model="searchEn" @change="calculateData(10)">
                                            <option value="" disabled selected>Seleccione Estado Entrega</option>
                                            <option value="0">Todos</option>
                                            <option value="1">Sin Entrega</option>
                                            <option value="2">Entregado</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- paginado -->
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-1 text-center px-3">
                            <div v-if="cpData.length > 0" class="d-flex justify-content-end">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination mb-1">
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                                            <a :class="selectPage === 1 ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(1)">1</a>
                                        </li>
                                        <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>

                                        <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                                            <a :class="selectPage === item ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                                            </a>
                                        </li>
                                        <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] <stepPagination.length - 1" class="page-item disabled">
                                            <span class="page-link">...</span>
                                        </li>
                                        <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length" class="page-item">
                                            <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active':'page-link'" href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}
                                            </a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div class="col-md-12 mt-2" id="content-timelinetable">
                            <table id="tb-cxc" class="table table-bordered border-main text-xs">
                                <caption class="py-0 my-0"></caption>
                                <thead class="bg-main">
                                    <tr class="table-th text-white text-center">
                                        <th scope="col">#</th>
                                        <th scope="col">N° DE OT</th>
                                        <th scope="col">FECHA DE REGISTRO</th>
                                        <th scope="col">CLIENTE</th>
                                        <th scope="col">TELEFONO</th>
                                        <th scope="col">FECHA TENTATIVA</th>
                                        <th scope="col">FECHA DE ENTREGA</th>
                                        <th scope="col" class="table-th-acciones">ESTADO DE PAGO</th>
                                        <th scope="col" class="table-th-acciones">ESTADO DE ENTREGA</th>
                                        <th scope="col" class="table-th-acciones">ACCIÓN</th>
                                    </tr>
                                </thead>
                                <tbody class="border-main">
                                    <tr class="table-body text-center" v-if="cpData.length === 0">
                                        <td colspan="10" class="text-center">No hay registros</td>
                                    </tr>
                                    <tr class="table-body text-center" v-for="(item, index) in cpData" :key="index">
                                        <td class="text-center align-middle">
                                            {{ mtdNumber(index) }}
                                        </td>
                                        <td class="text-center align-middle">
                                            OT-{{ item.id.toString().padStart(6, '0') }}
                                        </td>
                                        <td class="text-center align-middle">
                                            {{ item.date | formatDate}}
                                        </td>
                                        <td class="text-center align-middle">
                                            {{ item.patient ? item.patient.name  : '-'}}
                                        </td>
                                        <td class="text-center align-middle">
                                            {{ item.patient ? item.patient.phone  : '-'}}
                                        </td>
                                        <td class="text-center align-middle" @click="mtdOutFocusInput(index)">
                                            <input type="date" class="form-control form-control-sm input-cantidad" 
                                            :class="{'input-with-opacity':isButtonDisabled && posEditnumber !== index,}" v-if="item.tentative_date_edit == null" 
                                            v-model="item.tentative_date" 
                                            @change ="mtddatetentative(item)"/>
                                            <span v-else>
                                                {{ item.tentative_date | formatDate}}
                                            </span>
                                        </td>
                                        <td class="text-center align-middle">
                                            <template v-if="item.delivery_date">
                                                {{ item.delivery_date | formatDate}}
                                            </template>
                                            <template v-else>
                                                -
                                            </template>
                                        </td>
                                        <td class="text-center align-middle nowrap fw-semibold">
                                            <div id="state_speciality" v-if="item.state == 1">
                                                <div class="bg-danger text-white">Sin Pago</div>
                                            </div>
                                            <div id="state_speciality" v-if="item.state == 2">
                                                <div class="bg-warning">Pago Parcial</div>
                                            </div>
                                            <div id="state_speciality" v-if="item.state == 3">
                                                <div class="bg-success text-white">Pagado</div>
                                            </div>
                                        </td>
                                        <td class="text-center align-middle nowrap fw-semibold">
                                            <div id="state_speciality" v-if="item.delivery_state == 1">
                                                <div class="bg-dark text-white">Sin Entrega</div>
                                            </div>
                                            <div id="state_speciality" v-if="item.delivery_state == 2">
                                                <div class="bg-light">Entregado</div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="text-center d-flex justify-content-center">
                                                <button v-if="item.delivery_state == 1"
                                                    class="btn btn-sm a-success text-white" @click="editStateEn(item.id)"
                                                    title="Cambiar Estado de Entrega"
                                                >
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                                <button
                                                    class="btn btn-sm a-info text-white" @click="viewpdfOrdenTrabajo(item.id)"
                                                    title="Pdf Orden de Trabajo"
                                                >
                                                <i class="far fa-file-pdf"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" @mtdPermissionCommit="mtdPermissionCommit"/>
</div>
</template>

<script>
import {mapActions} from "vuex";
import moment from "moment";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
export default {
    name: "c-admision-viewOt",
    components: {
        SweetAlert,
    },
    data() {
        return {
            swal: null,
            dataShow: [],
            data: [],
            searchPa: "",
            searchEn: "",
            search: "",
            filter: {
                init: null,
                end: null,
                campu: this.$store.getters.get__campus
            },
            isButtonDisabled: false,
            posEditnumber: null,
            currentDate: moment().format('YYYY-MM-DD'),
            //Pag
            totalPagesToShow: 4,
            page: 0,
            selectPage: 1,
            stepPagination: [],
        };
    },
    created() {
        this.getFirstDayOfMonth();
        this.mtdGetData()
    },
    watch: {
        selectPage() {
            this.calculateData(10);
        },
    },
    computed: {
        cpData() {
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },
    },
    methods: {
        ...mapActions(["get", "post"]),

        getFirstDayOfMonth: function () {
            const currentDate = new Date();
            const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
            const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
            this.filter.init = firstDayOfMonth.toISOString().split('T')[0];
            this.filter.end = lastDayOfMonth.toISOString().split('T')[0];
        },

        mtdGetData: function () {
            this.search = "";
            this.searchEn = "";
            this.searchPa = "";
            this.post({
                url: this.$store.getters.get__url + "/ordenTrabajo/viewOrder",
                token: this.$store.getters.get__token,
                params: this.filter,
            })
            .then((response) => {
                this.data = response.data;
                this.calculateData(10);
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        calculateData(items) {
            let filteredData = this.data;

            if (this.search.length >= 2 && this.search != "") {
                let query = this.search.toString().toUpperCase();
                filteredData = filteredData.filter((element) => {
                    if (element.patient) {
                        let name = element.patient.name ? element.patient.name.toString().toUpperCase() : "";
                        let document = element.patient.document ? element.patient.document.toString().toUpperCase() : "";
                        return name.includes(query) || document.includes(query);
                    }
                });
            }

            if (this.searchPa && this.searchPa != 0) {
                filteredData = filteredData.filter(item => item.state == this.searchPa);
            }

            if (this.searchEn && this.searchEn != 0) {
                filteredData = filteredData.filter(item => item.delivery_state == this.searchEn);
            }

            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                length: totalPages,
            }, (_, index) => index + 1);

            let startIndex = (this.selectPage - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
        },

        viewpdfOrdenTrabajo: function (id) {
            window.open(
                this.$store.getters.get__url + "/viewpdfOrdenTrabajo/" + id,
                "_blank"
            );
        },

        editStateEn: function (id) {
            let msj = "A Entregado"
            this.$refs.SweetAlert.showPermisionsBtn(id, msj);
        },

        mtdPermissionCommit: function (id, value_select) {
            this.post({
                url: this.$store.getters.get__url + "/ordenTrabajo/editStateEn",
                token: this.$store.getters.get__token,
                params: {
                    id: id,
                    value_select: value_select
                },
            })
            .then((response) => {
                if(response.statusCode == 200) {
                    this.mtdGetData();
                } else {
                    this.$refs.SweetAlert.showError("Error");
                }
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        //Fecha Tentativa
        mtdOutFocusInput(index) {
            if (this.posEditnumber !== index && this.posEditnumber !== null) {
                Swal.fire({
                    title: "Desea cambiar de fila?",
                    text: "Se borrarán los datos registrados!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Si, cambiar!",
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.posEditnumber = index;
                    }
                });
            } else {
                this.posEditnumber = index;
            }

            this.isButtonDisabled = true;
        },

        mtddatetentative:function(payload){
            let data ={
                'tentative_date' : payload.tentative_date,
                'id': payload.id
            }
            let fechaTentativa = moment(payload.tentative_date).format("DD/MM/YYYY"); 
            this.$refs.SweetAlert.showConfirmSimple2(`¿Desea Registrar la Fecha Tentativa? (${fechaTentativa})`,"","warning","Confirmar") 
            .then((result) => {
                if (result.value) {
                    this.mtddatetentativeinsert(data);
                }
            });
        },

        mtddatetentativeinsert: function (data) {
            this.post({
                url: this.$store.getters.get__url + "/ordenTrabajo/storedatetentative",
                token: this.$store.getters.get__token,
                params: data,
            })
            .then((response) => {
                if (response.statusCode == 200) { 
                    this.$refs.SweetAlert.showSuccess("Fecha Tentativa Registrada");
                    this.mtdGetData();
                }
            })
            .catch((errors) => {
                this.$refs.SweetAlert.showError(errors);
            });
        },

        //Pag
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage = this.selectPage < this.stepPagination.length ? this.selectPage + 1 : this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
        mtdNumber: function (index) {
            return (this.selectPage - 1) * 10 + (index + 1)
        },

        //Retroceder
        mtdChangeView: function (option) {
            this.$emit("mtdChangePage", option);
        },

        returnHome: function () {
            this.$emit("returnHome");
        },
    },
    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
        formatDateTime(dateTime) {
            return dateTime != null ? moment(dateTime).format("DD/MM/YYYY HH:mm") : "-";
        },
    },
}
</script>
<style scoped>
.input-with-opacity {
    opacity: 0.4;
}
</style>

